<template>
  <div class="container">
    <span class="title is-3">{{empresa.nombrec}}</span>
    <small class="title is-5">{{empresa.nit | textnumber()}}{{empresa.nit | dverif()}}</small>
    <small class="subtitle is-7">{{empresa.nombre}}</small>
    <hr />
    <div style="margin-top: 32px; margin-bottom:32px;">
      <button class="button is-medium is-light" @click="editable = true, create = true">
        <span class="icon is-small">
          <span class="material-icons">add_circle_outline</span>
        </span>
        <span>Crear Unidad de medida</span>
      </button>
    </div>
    <div>
      <p class="title">Unidades de medida</p>
    </div>
    <div class="table-container" v-if="editable == false">
      <table class="table is-hoverable is-fullwidth">
        <thead>
          <tr>
            <th>Nomenclatura</th>
            <th>Descripción</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-for="(unit, index) in units" :key="index">
          <tr>
            <th>{{unit.codigo}}</th>
            <td style="display:flex; justify-content:space-between">{{unit.descripcion}}</td>
            <td>
              <span class="icon has-text-info hand" @click="selectEdit(unit)">
                <i class="material-icons">edit</i>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <hr />
    <div class="columns" v-if="editable == true">
      <div class="column">
        <p class="title is-5">Nomenclatura</p>
        <div>
          <input
            v-model="newNomenclature"
            name="input-edit-code"
            id="input-edit-code"
            class="input is-medium"
            type="text"
            placeholder="Código"
          />
        </div>
      </div>
      <div class="column">
        <p class="title is-5">Descripción</p>
        <div>
          <input
            class="input is-medium"
            type="text"
            placeholder="Descripción"
            v-model="newDescription"
          />
        </div>
      </div>
    </div>
    <div class="columns" v-if="editable == true">
      <div class="column">
        <div class="buttons" style="margin-top:16px;">
          <button class="button is-medium is-info" v-if="create==true" v-on:click="createUnits()">
            <span class="icon is-small">
              <span class="material-icons">save</span>
            </span>
            <span>Guardar</span>
          </button>
          <button class="button is-medium is-info" v-if="create == false" v-on:click="editUnits()">
            <span class="icon is-small">
              <span class="material-icons">edit</span>
            </span>
            <span>Editar</span>
          </button>
          <button
            class="button is-medium"
            @click="editable = false, create = false, getUnits()"
          >Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      units: [],
      editable: false,
      create: false,
      unitSelected: {},
      newNomenclature: "",
      newDescription: "",
    };
  },
  computed: {
    ...mapState(["empresa", "productos"]),
  },
  methods: {
    selectEdit(unit) {
      this.editable = true;
      this.unitSelected = unit;
      this.newNomenclature = unit.codigo;
      this.newDescription = unit.descripcion;
    },
    async createUnits() {
      try {
        this.units = [];
        if (this.newNomenclature !== "" && this.newDescription !== "") {
          const result = await apiServices.post(`/createunits`, {
            codigo: this.newNomenclature,
            descripcion: this.newDescription,
          });
          if (result.data && result.data.message) {
            this.$store.dispatch("notify", {
              message: "El código ya se encuentra en la base de datos.",
              type: "is-danger",
              position: "top-center",
            });
            this.getUnits();
          } else {
            this.editable = false;
            this.newNomenclature = "";
            this.newDescription = "";
            this.$store.dispatch("notify", {
              message: "Perfecto!. Unidad de medida creado.",
            });
            this.getUnits();
            console.log(result);
          }
        } else {
          this.$store.dispatch("notify", {
            message: "Llena todos los campos",
            type: "is-warning",
          });
          this.getUnits();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async editUnits() {
      try {
        this.units = [];
        if (this.newNomenclature !== "" && this.newDescription !== "") {
          const result = await apiServices.post(`/editunits`, {
            codigo: this.newNomenclature,
            descripcion: this.newDescription,
            _id: this.unitSelected._id,
          });
          if (result.data && result.data.message) {
            this.$store.dispatch("notify", {
              message: "El código ya se encuentra en la base de datos.",
              type: "is-danger",
              position: "top-center",
            });
            this.getUnits();
          } else {
            this.editable = false;
            this.newNomenclature = "";
            this.newDescription = "";
            this.$store.dispatch("notify", {
              message: "Perfecto!. unidad de medida editada con éxito.",
            });
            this.getUnits();
          }
        } else {
          this.$store.dispatch("notify", {
            message: "Llena todos los campos",
            type: "is-warning",
          });
          this.getUnits();
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getUnits() {
      try {
        this.units = [];
        const result = await apiServices.get(`/listunits`);
        this.units = result.data;
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.getUnits();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/configurations/measurementunits/Measurementunits.vue